import React, { useEffect } from "react";

export default function VitalsForm({ vitals, onChange, templateId, isEditing=true }) {
  const set = (k, v) => onChange({ ...vitals, [k]: v });

  // Verificar si es el template de Hospital Discharge Follow Up o Annual Wellness
  const isHospitalDischargeTemplate = templateId === "100001773";
  const isAnnualWellnessTemplate = templateId === "100001775";

  // Auto BMI calculation
  useEffect(() => {
    if (vitals.Vitals_Weight > 0 && vitals.Vitals_Height > 0) {
      const bmi = Math.round(((vitals.Vitals_Weight / (vitals.Vitals_Height * vitals.Vitals_Height)) * 703) * 10) / 10;
      if (bmi !== vitals.Vitals_BMI) {
        onChange({ ...vitals, Vitals_BMI: bmi });
      }
    }
  }, [vitals.Vitals_Weight, vitals.Vitals_Height, vitals.Vitals_BMI]);

  return (
    <div className="cn-card">
      <h3>🩺 Vital Signs</h3>
      <div className="row">
        <div>
          <label>
            <span style={{ marginRight: 8 }}>⚖️</span>
            Weight (lbs)
          </label>
          <input 
            type="number" 
            value={vitals.Vitals_Weight || ""} 
            onChange={(e) => set("Vitals_Weight", Number(e.target.value))} 
            disabled={!isEditing}
          />
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>📏</span>
            Height (in)
          </label>
          <input 
            type="number" 
            value={vitals.Vitals_Height || ""} 
            onChange={(e) => set("Vitals_Height", Number(e.target.value))} 
            disabled={!isEditing}
          />
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>📊</span>
            BMI
          </label>
          <input type="number" value={vitals.Vitals_BMI || ""} readOnly />
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>🌡️</span>
            Temperature (°F)
          </label>
          <input 
            type="number" 
            value={vitals.Vitals_Temperature || ""} 
            onChange={(e) => set("Vitals_Temperature", Number(e.target.value))} 
            disabled={!isEditing}
          />
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>❤️</span>
            Pulse (bpm)
          </label>
          <input 
            type="number" 
            value={vitals.Vitals_Pulse || ""} 
            onChange={(e) => set("Vitals_Pulse", Number(e.target.value))} 
            disabled={!isEditing}
          />
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>🫁</span>
            O₂ Sat (%) Room Air
          </label>
          <input 
            type="number" 
            value={vitals.Vitals_O2SatRA || ""} 
            onChange={(e) => set("Vitals_O2SatRA", Number(e.target.value))} 
            disabled={!isEditing}
          />
        </div>
      </div>

      {/* Campos de presión arterial previa para los templates que los incluyen */}
      {(isHospitalDischargeTemplate || isAnnualWellnessTemplate) && (
        <div className="row">
          <div>
            <label>
              <span style={{ marginRight: 8 }}>🩺</span>
              Previous BP Systolic
            </label>
            <input 
              type="number" 
              value={vitals.Vitals_BP_SystolicPrev || ""} 
              onChange={(e) => set("Vitals_BP_SystolicPrev", Number(e.target.value))} 
              disabled={!isEditing}
            />
          </div>
          <div>
            <label>
              <span style={{ marginRight: 8 }}>🩺</span>
              Previous BP Diastolic
            </label>
            <input 
              type="number" 
              value={vitals.Vitals_BP_DiastolicPrev || ""} 
              onChange={(e) => set("Vitals_BP_DiastolicPrev", Number(e.target.value))} 
              disabled={!isEditing}
            />
          </div>
        </div>
      )}

      <div className="row">
        <div>
          <label>
            <span style={{ marginRight: 8 }}>🩺</span>
            BP #1 Systolic
          </label>
          <input 
            type="number" 
            value={vitals.Vitals_BP_Systolic1 || ""} 
            onChange={(e) => set("Vitals_BP_Systolic1", Number(e.target.value))} 
            disabled={!isEditing}
          />
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>🩺</span>
            BP #1 Diastolic
          </label>
          <input 
            type="number" 
            value={vitals.Vitals_BP_Diastolic1 || ""} 
            onChange={(e) => set("Vitals_BP_Diastolic1", Number(e.target.value))} 
            disabled={!isEditing}
          />
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>🪑</span>
            BP Position
          </label>
          <select value={vitals.Vitals_BP_Option1 || ""} onChange={(e) => set("Vitals_BP_Option1", e.target.value)} disabled={!isEditing}>
            <option value="">Select position</option>
            <option value="1">Sitting</option>
            <option value="2">Standing</option>
            <option value="3">Supine</option>
          </select>
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>🫱</span>
            BP Arm
          </label>
          <select value={vitals.Vitals_BP_Location1 || ""} onChange={(e) => set("Vitals_BP_Location1", e.target.value)} disabled={!isEditing}>
            <option value="">Select arm</option>
            <option value="1">Left</option>
            <option value="2">Right</option>
          </select>
        </div>
      </div>
    </div>
  );
}